import Button from '@/components/Button';
import PageHeader from '@/components/PageHeader';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import RetailerTable from '@/modules/admin/components/RetailerTable';
import { RetailerAddPath } from '@/modules/admin/paths';
import { PlusIcon } from '@heroicons/react/24/solid';

const RetailerList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <div>
      <Breadcrumbs />

      <PageHeader title="Retailers">
        <Button
          to={RetailerAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Create Retailer
        </Button>
      </PageHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <RetailerTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </div>
  );
};

export default RetailerList;
